import { authSlice } from '../slices';

export const { setUser, clearUser, setLoader } = authSlice.actions;
